module.exports = __webpack_public_path__ + "img/icons8-volvo.9cbcc550.svg";